import { gql } from 'urql';

const UserWithDefaultTenant = gql`
  fragment UserWithDefaultTenantFragment on User {
    id
    defaultTenantId
    defaultTenant {
      id
      address
      displayName
      ownerId
      slug
      permissions {
        aggregationLevels
        apiPermissions {
          historicalViewAccess
          realTimeAccess
          metadataAccess
          rateLimitCount
        }
        maxRange
        monthlyDownloads
        maxHistoricalMonths
        restrictedData
        dataSources
        countries
        states
      }
      remainingDownloads
      remainingSearches
      platformPricingTier
      dashboards {
        id
        tenantId
        key
        title
        supersetDashboardId
        position
      }
    }
    email
    phone
    isEmailVerified
    firstName
    lastName
    displayName
    language
    externalNotificationId
    hasCompletedOnboarding
    role
    status
    createdAt
    version
  }
`;

export default UserWithDefaultTenant;
